
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import Editor from "@common/src/components/scope/editor/index.vue";
import { emptyToLine } from "@common/src/utils/common";
import CouponDiscountContent from "../components/coupon-discount-content.vue";
import QRCode from "qrcodejs2";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import CampaignQrCode from "./components/campaign-qr-code.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import CouponContent from "../components/coupon-discount-content.vue";
import ItemBlock from "@common/src/components/scope/item-block/index.vue";
import ImgLoader from "@common/src/components/scope/img-loader/index.vue";
import t from "@common/src/i18n/t";

const campaign = namespace("campaign");
const store = namespace("store");
const marketing = namespace("marketing");
@InjectFunction("dayjs", "permitApp")
@Component({
  components: { Editor, CouponDiscountContent, CampaignQrCode, CouponContent, ItemBlock, ImgLoader }
})
export default class CollectCustomerEdit extends Vue {
  @store.State storeData;
  @campaign.Action queryCampaignDetail;
  @marketing.Action queryFissionCampaign;
  @marketing.Action getFissionQrCodeUrlV2;
  @marketing.Action getWxSchemeUrl;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  campaignForm: any = {
    id: "111111",
    campaignName: "",
    campaignBeginTime: "",
    campaignEndTime: "",
    campaignImage: "",
    campaignDesc: "",
    isCoupon: "0",
    campaignContext: "",
    campaignImageColor: "rgb(251,132, 28)",
    prize: {
      bindCode: "",
      bindObj: {}
    },
    fissionPrize: {
      bindCode: "",
      cardTemplateResult: {},
      prizeAmount: "",
      prizeQty: ""
    },
    // 非业务直接参数
    time: [],
    bannerType: "default" // default customize
  };
  showLinkQr: boolean = false;
  get couponInfo() {
    return this.campaignForm.prize ? this.campaignForm.prize.bindObj : {};
  }
  campaignFormRules: any = {};
  get breadData() {
    return [
      { name: t("v210801.fission-activity"), path: "/marketing/campaign/fission-campagin" },
      {
        name: t("v210801.view-fission-activity")
      }
    ];
  }
  get isAdd() {
    return this.$route.name === "marketingCardTemplateAdd";
  }

  mounted() {
    this.init();
  }
  get id() {
    return this.$route.params.id;
  }
  init() {
    this.queryFissionCampaign({ campaignCode: this.id }).then(data => {
      console.log("[ data ]", data);
      this.campaignForm = data.data;
    });
  }
  qrCode(url) {
    document.getElementById("qrcode").innerHTML = "";
    let qrcode = new QRCode("qrcode", {
      width: 120, //图像宽度
      height: 120, //图像高度
      colorDark: "#000000", //前景色
      colorLight: "#ffffff", //背景色
      typeNumber: 4,
      correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
    });
    qrcode.clear(); //清除二维码
    qrcode.makeCode(url); //生成另一个新的二维码
  }
  activeRow: any = {};
  qrData: any = {};
  handleComfirmCommand(command) {
    if (command === "push") {
      this.$router.push(`/marketing/campaign/fission-send-collect/${this.campaignForm.campaignCode}`);
    } else if (command === "copyLink") {
      this.activeRow = this.campaignForm;
      this.showLinkQr = true;
      let page = "pages/index/index";
      this.getFissionQrCodeUrlV2({
        campaignCode: this.campaignForm.campaignCode,
        page
      }).then(data => {
        this.qrData = data.data;
      });
    }
  }
  handleEdit() {
    this.$router.push(`/marketing/campaign/fission-campagin-add/${this.id}`);
  }
  get storeTypeDescList() {
    return this.campaignForm.storeTypesDesc ? this.campaignForm.storeTypesDesc.split(",") : [];
  }
}
